export default {
  api: {
    url: process.env.REACT_APP_API_URL,
    token: process.env.REACT_APP_API_TOKEN
  },
  googleAnalytics: {
    trackingId: process.env.REACT_APP_GA_TRACKING_ID
  }
};
